<template>
  <div class="system-menu-container">
    <!-- TAB 切换栏 -->
    <el-tabs v-model="activeTab" type="card" @tab-click="handleTabClick">
      <el-tab-pane label="发版管理" name="release" />
      <el-tab-pane label="FAQ管理" name="faq" />
 
    </el-tabs>

    <!-- 动态渲染子组件 -->
    <div class="tab-content">
      <!-- 1. 菜单管理 -->
      <Release v-if="activeTab === 'release'" ref="releaseTable" />
	  <FaqTable v-if="activeTab === 'faq'" ref="faqTable" />

    </div>
  </div>
</template>

<script>
// 导入所有子组件
import Release from './components/release.vue'
import FaqTable from './components/faqtable.vue'

export default {
  name: 'Information',
  components: {
		Release,
		FaqTable
  },
  data() {
    return {
      activeTab: 'release' // 默认显示菜单管理
    }
  },
  methods: {
    // TAB 切换事件
    handleTabClick(tab) {
      this.activeTab = tab.name
    }
  }
}
</script>

<style scoped>
.system-menu-container {
  padding: 20px;
}
.tab-content {
  margin-top: 20px;
}
</style>